import React, {useEffect, useState} from "react";
import {DataTable} from "primereact/datatable";
import {enums} from "../../../constants";
import utils from "../../../utils/index";
import {Card} from "primereact/card";

export const ConsultaBaixaForm = props => {
    const record = props.record;
    let arquivo = "";
    if (record.nome) {
        arquivo = " Arquivo: " + record.nome;
    }
    let total = "";
    if (record.valor) {
        total = " Total: R$ " + utils.formatCurrency(record.valor);
    }

    const totalRecords = utils.isArrayNullOrEmpty(record.itens) ? 0 : record.itens.length;
    // Os filtros da tabela de itens são locais do DataTable: ele repagina, mas totalRecords continua
    // sendo o arquivo inteiro. A contagem filtrada chega por onValueChange; null = sem filtro aplicado.
    const [totalItensFiltrados, setTotalItensFiltrados] = useState(null);

    useEffect(() => {
        setTotalItensFiltrados(null);
    }, [record.itens]);

    return (
        <div className="p-grid p-fluid">
            <div className="p-col-12">
                <div className="card card-w-title">
                    <h3>
                        {utils.getMessage(props.messages, "consultabaixa.label.consultaBaixas")} {record.oid || ""}
                    </h3>
                    <h4>{arquivo || ""}</h4>
                    <h4>{total || ""}</h4>
                    <div className="p-grid form-group">
                        <div className="p-col-12 p-sm-12 p-md-12 p-lg-12 p-xl-12">
                            <DataTable
                                autoLayout={true}
                                reorderableColumns={true}
                                resizableColumns={true}
                                columnResizeMode="expand"
                                ref={props.dataTableItens}
                                paginator={true}
                                emptyMessage="Não foram encontrados registros"
                                rows={15}
                                rowsPerPageOptions={enums.ROWSPERPAGEOPTIONS}
                                value={record.itens}
                                onRowSelect={props.onRowSelect}
                                selectionMode="single"
                                onValueChange={filtrados => setTotalItensFiltrados(filtrados.length)}
                                totalRecords={totalRecords}
                            >
                                {props.colunasItens}
                            </DataTable>
                            <br/>
                            <Card style={{ margin: "5px" }} className="ui-card-shadow">
                                <div style={{ textAlign: "right" }}>
                                    <strong>Total: </strong> {totalItensFiltrados ?? totalRecords}
                                </div>
                            </Card>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};
